
import { useState, useEffect, useRef } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const useLocalSearch = (debounceMs = 300) => {
  const [query, setQuery] = useState("");
  const [indexResults, setIndexResults] = useState([]);
  const [equityResults, setEquityResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    clearTimeout(timerRef.current);

    if (query.trim().length < 2) {
      setIndexResults([]);
      setEquityResults([]);
      return;
    }

    timerRef.current = setTimeout(async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${BASE_URL}/api/search-db-stocks`, {
          params: { query },
        });
        setIndexResults(res?.data?.indices || []);
        setEquityResults(res?.data?.equities || []);
      } catch (err) {
        setIndexResults([]);
        setEquityResults([]);
      } finally {
        setLoading(false);
      }
    }, debounceMs);

    return () => clearTimeout(timerRef.current);
  }, [query]);

  const clearResults = () => {
    setQuery("");
    setIndexResults([]);
    setEquityResults([]);
  };

  return {
    query,
    setQuery,
    indexResults,
    equityResults,
    loading,
    clearResults,
  };
};

export default useLocalSearch;
